import './Checkout.css';
import React, { useEffect } from 'react';

import { BASE_URL } from '../../config/environmentConfig';
import { useNavigate, useLocation } from 'react-router-dom';
import { flowType, useDemo } from '../../store/DemoContext';

interface Props {}

const TerminalIframe: React.FC<Props> = () => {
  const {
    state: { flow },
  } = useDemo();

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    window?.addEventListener('message', function (event) {
      switch (event.data) {
        case 'decline':
          navigate('/decline?isTerminal=true');
          break;
        case 'success':
          navigate('/success');
          break;
      }

      if (event?.data?.message === 'redirect' && event?.data?.url) {
        navigate(event?.data?.url);
      }
    });
  }, []);

  return (
    <div className="CheckoutIframe">
      <iframe
        data-cy="payment-frame"
        title="123456789"
        id="terminal"
        src={`${window?.location.origin}/terminal?id=123456789`}
        frameBorder="0"
      />
    </div>
  );
};

export default TerminalIframe;
